import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { LoadedDocument } from '../../core/services/utility.service';
import { Subscription } from 'rxjs';
import { PopupState } from './popup';
import { PopupService } from '../../core/services/popup.service';
import { animate, style, transition, trigger } from '@angular/animations';
// import {BackendService} from '../../core/services/backend.service';

@Component({
	selector: 'app-popup',
	templateUrl: './popup.component.html',
	styleUrls: ['./popup.component.scss'],
	animations: [
		trigger('fadeInOut', [
			transition(':enter', [   // :enter is alias to 'void => *'
				style({ opacity: 0 }),
				animate(200, style({ opacity: 1 }))
			]),
			transition(':leave', [   // :leave is alias to '* => void'
				animate(200, style({ opacity: 0 }))
			])
		])
	]
})
export class PopupComponent implements OnInit, OnDestroy {
	@Input() isVisible: boolean;
	@Input() title: string;
	@Input() description: string;
	@Input() hideX?: boolean;
	@Input() textButton?: string = null;
	@Input() params?: any = null;
	@Input() arrayDocs?: any = null;
	@Input() codiceTipoDoc?: string = null;
	@Output() clickButton = new EventEmitter();
	@Output() clickDoc = new EventEmitter();
	@Output() deleteDoc = new EventEmitter();
	confirmSelection = false;
	listaDocs = [];
	docBeingDeleted;
	private subscription: Subscription;

	constructor(
		private popupService: PopupService
	) { }

	ngOnInit() {
		this.subscription = this.popupService.popupState
			.subscribe((state: PopupState) => {
				this.isVisible = state.isVisible;
				this.title = state.title;
				this.description = state.description;
				this.hideX = state.hideX;
				this.textButton = state.textButton;
				this.params = state.params;
				this.arrayDocs = state.arrayDocs;
				this.codiceTipoDoc = state.codiceTipoDoc;
				this.listaDocs = [];
				if (this.arrayDocs && this.codiceTipoDoc) {
					this.listaDocs = this.arrayDocs.filter(
						x => x.codiceTipoDocumento === this.codiceTipoDoc
					);
				}
			});
	}

	ngOnDestroy() {
		this.resetConfirmation();
		this.subscription.unsubscribe();
	}

	textButtonClick() {
		this.clickButton.emit();
	}

	clickOnDoc(doc) {
		this.clickDoc.emit(doc);
	}

	deleteButtonClick(doc) {
		this.confirmSelection = true;
		this.docBeingDeleted = doc;
	}

	deleteFeedback(result = true) {
		if (result) {
			this.deleteDoc.emit(this.docBeingDeleted);
		}
		this.resetConfirmation();
	}

	resetConfirmation() {
		this.docBeingDeleted = null;
		this.confirmSelection = false;
	}

	getSortedDocList = (docList: LoadedDocument[]) => docList.sort((a, b) => a.numeroPagina - b.numeroPagina)
}
